// src/hooks/useAppleSignIn.js
import { signInWithPopup, OAuthProvider } from 'firebase/auth';
import { auth } from '../config/firebase';
import AuthenticationService from '../services/AuthenticationService';

export const useAppleSignIn = () => {
  const signIn = async ({ affiliate = null, newsletter = false } = {}) => {
    try {
      const provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');

      const result = await signInWithPopup(auth, provider);
      const firebaseIdToken = result._tokenResponse.idToken;

      if (!firebaseIdToken) {
        throw new Error('No Firebase token from Apple popup');
      }

      // Use firebaseLogin (POST /auth/firebase/login) - handles Apple provider internally
      const response = await AuthenticationService.firebaseLogin({
        token: firebaseIdToken,  // Firebase JWT
        username: false,
        affiliate: affiliate,  // From URL/search params TODO
        newsletter: newsletter
      });
      return response;

    } catch (error) {
      console.error('Apple login error:', error);
      throw error;
    }
  };
  return { signIn };
};
